import { CircularProgress, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spinner: {
      position: 'fixed',
      bottom: '50%',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  })
)

interface Props {
  children?: any
}

export const ErrorSpinner: React.FC<Props> = ({ children }) => {
  const [showSpinner, setShowSpinner] = useState(false)
  const classes = useStyles()
  useEffect(() => {
    const timer = setTimeout(setShowSpinner, 300, true)
    return () => clearTimeout(timer)
  }, [])
  return showSpinner ? (
    <>
      <div className={classes.spinner}>
        <CircularProgress />
      </div>
      {children}
    </>
  ) : (
    <>{children}</>
  )
}
